"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberRoleEnum = void 0;
var MemberRoleEnum;
(function (MemberRoleEnum) {
    MemberRoleEnum["ADMIN"] = "admin";
    MemberRoleEnum["MEMBER"] = "member";
})(MemberRoleEnum = exports.MemberRoleEnum || (exports.MemberRoleEnum = {}));
